import { AlertsPageLazy } from './alertsPageLazy';

const props = [];

export const AlertsPageLazyDirective = reactDirective => reactDirective(AlertsPageLazy, props);
AlertsPageLazyDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('alerts', AlertsPageLazyDirective);